import React from 'react';
import { Box, Title } from '@components';

const EmptyList = () => {
  return (
    <Box className="h-[calc(100vh-250px)] grid place-items-center">
      <Title tag="h2">Soru bulunamadı.</Title>
    </Box>
  );
};

export default EmptyList;
